import { useEffect } from 'react';
import setDesktopWidth from '@/utilites/set-desktop-width';
import setMobileWidth from '@/utilites/set-mobile-width';

function useMonitorWindowWidth(
  setExternalWidth?: React.Dispatch<React.SetStateAction<number>>
) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mediaQuery = window.matchMedia('(max-width: 992px)');
      const handleMediaQueryChange = (e: MediaQueryListEvent) => {
        if (e.matches) {
          setMobileWidth(setExternalWidth);
        } else {
          setDesktopWidth(setExternalWidth);
        }
      };

      if (mediaQuery.matches) {
        setMobileWidth(setExternalWidth);
      } else {
        setDesktopWidth(setExternalWidth);
      }

      mediaQuery.addEventListener('change', handleMediaQueryChange);

      return () =>
        mediaQuery.removeEventListener('change', handleMediaQueryChange);
    }
  }, [setExternalWidth]);
}

export default useMonitorWindowWidth;
